"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiSupplierDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_supplier_merchant_dto_1 = require("./billing-api-supplier-merchant.dto");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const billing_core_supplier_business_type_enum_1 = require("../../../../billing-core/billing-core-supplier/types/enums/billing-core-supplier-business-type.enum");
/**
 * Базовая информация о поставщике, необходимая для создания или обновления карточки
 */
let BillingApiSupplierDto = class BillingApiSupplierDto {
  constructor() {
    this.businessType = billing_core_supplier_business_type_enum_1.BillingCoreSupplierBusinessTypeEnum.INDIVIDUAL;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента",
  format: "uuid"
  // readOnly: true,
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id мерчант-провайдера"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Активен",
  type: "boolean",
  required: false,
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Двухзначный код страны",
  format: "^[A-Z][A-Z]$",
  example: "US"
}), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(2, 2), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата рождения (только для businessType=INDIVIDUAL)",
  format: "date",
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "dob", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Электронная почта",
  format: "email"
}), (0, class_validator_1.IsEmail)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Телефон",
  format: "phone"
}), (0, class_validator_1.IsPhoneNumber)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "phone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имя или название компании"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Фамилия (только для businessType=INDIVIDUAL)",
  required: false,
  nullable: true,
  type: String
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Отчество (только для businessType=INDIVIDUAL)",
  required: false,
  nullable: true,
  type: String
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "thirdName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Тип занятости",
  default: billing_core_supplier_business_type_enum_1.BillingCoreSupplierBusinessTypeEnum.INDIVIDUAL,
  enum: [...Object.values(billing_core_supplier_business_type_enum_1.BillingCoreSupplierBusinessTypeEnum)]
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierDto.prototype, "businessType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Прямые платежи от учеников",
  required: false,
  nullable: true,
  default: false,
  type: Boolean
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "cardPayments", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Информация о интеграции с мерчант-провайдером",
  type: () => billing_api_supplier_merchant_dto_1.BillingApiSupplierMerchantDto,
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Type)(() => billing_api_supplier_merchant_dto_1.BillingApiSupplierMerchantDto), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierDto.prototype, "merchant", void 0);
BillingApiSupplierDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiSupplierDto);
exports.BillingApiSupplierDto = BillingApiSupplierDto;
